<template>
  <div>
    <DraggableFormSimple v-if="!this.$store.state.question.sections.length" />
    <DraggableFormSection v-else />
  </div>
</template>

<script>
import DraggableFormSimple from '@/components/question/simple/draggable/DraggableFormSimple'
import DraggableFormSection from '../question/section/draggable/draggableFormSection.vue'

export default {
  components: {
    DraggableFormSimple,
    DraggableFormSection
  },
  updated () {
    this.$nextTick(function () {
      let message = {
        height: document.body.scrollHeight
      }
      window.top.postMessage(message, '*')
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/BlocQuestions.vue